
import React, { Component } from 'react';
import _ from 'lodash'
import PriceItem from './PriceItem';
import UssdItem from './UssdItem';
import { motion } from "framer-motion";
import Footer from '../../components/Footer/Footer';
import { connect } from 'react-redux';
import { pageTitle } from './../../actions'
import ContentLoader from "react-content-loader";
import logo from './../../assets/images/logo.png'
import { tabChange } from './../../actions'
import { checkInternet } from './../../utils/checkInternet'
import { hasInternet , isHome } from './../../actions'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import {

    isPushNotificationSupported,
    initializePushNotifications,
} from "./../../push-notifications.js";


const spring = {
    type: "spring",
    damping: 60,
    stiffness: 300,


};
class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: [],
            openNotification:false,
            socket: null,
            current_tab: {
                home: false,
                search: false,
                ussd: false
            }
        }
    }
    
    componentDidMount() {
        // const getNotificationPermissionState = async () => {
        //     if (navigator.permissions) {
        //         let result = await navigator.permissions.query({ name: 'notifications' })
        //
        //         if (result.state === 'prompt') {
        //             this.setState({ openNotification: true });
        //         }else{
        //             this.setState({ openNotification: false });
        //         }
        //         return result.state;
        //     }
        // }

        this.props.dispatch(isHome(true))
        this.props.dispatch(hasInternet(checkInternet()))
        this.props.dispatch(pageTitle("صفحه اصلی"));
        this.props.socket !== null ? this.getData(this.props.socket) : console.log();
        this.props.dispatch(tabChange("home"));
        const { current_tab } = this.state;
        const tabs = this.state.current_tab;
        if (this.props.selectedTab) {
            for (let key in current_tab) {
                key === this.props.selectedTab ? tabs[key] = true : tabs[key] = false;
            }
            this.setState({ current_tab: tabs })
        }
    }
    componentWillReceiveProps(nextProps) {
        nextProps.socket !== null ? this.getData(nextProps.socket) : console.log();
        const { current_tab } = this.state;
        const tabs = this.state.current_tab;
        this.props.dispatch(hasInternet(checkInternet()));
        if (nextProps.selectedTab) {
            for (let key in current_tab) {
                key === nextProps.selectedTab ? tabs[key] = true : tabs[key] = false;
            }
            this.setState({ current_tab: tabs })
        }

    }

    getData = socket => {
        socket.on('home', data => {
            this.setState({ item: data, connected: socket.connected })

        })
        socket.emit("home", (res) => {
        });
        socket.on('ussd', data => {
            this.setState({ ussd: data, connected: socket.connected })

        })
        socket.emit("ussd", (res) => {
        });
    }
    handleClose = () => {
        this.setState({ openNotification: false });
    }
    handleEnableNotifications = async () => {
        this.setState({ openNotification: false });
        const getNotificationPermissionState = async () => {
            if (navigator.permissions) {
                let result = await navigator.permissions.query({ name: 'notifications' })
                return result.state;
            }
        }


        let currentPermissionState = getNotificationPermissionState()
        if (currentPermissionState === 'denied') {
            console.warn('the notification permission has been blocked')
            //disableNotificationBtn();
        }

        if (!('serviceWorker' in navigator) && !('PushManager' in window)) {
            return;
        }

        if (currentPermissionState !== 'granted') {
            let result = await Notification.requestPermission()
            if (result !== 'granted') {
                return;
            } else {
                const pushNotificationSuported = isPushNotificationSupported();
                if (pushNotificationSuported) {
                    initializePushNotifications().then(function (consent) {
                        if (consent === 'granted') {
                           
                            //sendNotification();
                        }
                    });
                }
            }
        }

    }
    render() {
        const { current_tab, item, connected, ussd, openNotification } = this.state;
        const { app_name } = this.props;
        const MyLoader = () => (
            <ContentLoader
                height={40}
                rtl={true}
                speed={2}
            >
                <rect x="80%" y="25" rx="3" ry="3" width="60" height="7" />
                <rect x="20" y="25" rx="4" ry="4" width="150" height="7" />


            </ContentLoader>
        );
        return (
            <div>
                <div className="mainPage">
                    <div className="hero-header">
                        <img src={logo} className="home-logo" alt="logo" />
                        <h3 className="app-title">{app_name.title} <span>{app_name.subtitle}</span></h3>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,288L10.4,288C20.9,288,42,288,63,256C83.5,224,104,160,125,149.3C146.1,139,167,181,188,186.7C208.7,192,230,160,250,160C271.3,160,292,192,313,176C333.9,160,355,96,376,74.7C396.5,53,417,75,438,90.7C459.1,107,480,117,501,128C521.7,139,543,149,563,154.7C584.3,160,605,160,626,160C647,160,668,160,689,181.3C709.6,203,730,245,751,229.3C772.2,213,793,139,814,101.3C834.8,64,856,64,877,80C897.4,96,918,128,939,128C960,128,981,96,1002,74.7C1022.6,53,1043,43,1064,48C1085.2,53,1106,75,1127,85.3C1147.8,96,1169,96,1190,90.7C1210.4,85,1231,75,1252,80C1273,85,1294,107,1315,101.3C1335.7,96,1357,64,1377,69.3C1398.3,75,1419,117,1430,138.7L1440,160L1440,320L1429.6,320C1419.1,320,1398,320,1377,320C1356.5,320,1336,320,1315,320C1293.9,320,1273,320,1252,320C1231.3,320,1210,320,1190,320C1168.7,320,1148,320,1127,320C1106.1,320,1085,320,1064,320C1043.5,320,1023,320,1002,320C980.9,320,960,320,939,320C918.3,320,897,320,877,320C855.7,320,835,320,814,320C793,320,772,320,751,320C730.4,320,710,320,689,320C667.8,320,647,320,626,320C605.2,320,584,320,563,320C542.6,320,522,320,501,320C480,320,459,320,438,320C417.4,320,397,320,376,320C354.8,320,334,320,313,320C292.2,320,271,320,250,320C229.6,320,209,320,188,320C167,320,146,320,125,320C104.3,320,83,320,63,320C41.7,320,21,320,10,320L0,320Z"></path></svg>
                    </div>
                    {current_tab.home ?
                        <ul className="price-list home-menu">
                            {
                                connected ?
                                    _.map(item, (item, index) => {
                                        return (
                                            <motion.li
                                                key={index}
                                                layoutTransition={spring}
                                            >
                                                <PriceItem item={item} />
                                            </motion.li>
                                        )
                                    })


                                    :
                                    <React.Fragment>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                    </React.Fragment>
                            }
                        </ul>
                        : null}

                    {current_tab.ussd ?
                        <ul className="price-list ussd">
                            {
                                connected ?
                                    _.map(ussd, (item, index) => {
                                        return (
                                            <motion.li
                                                key={index}
                                                layoutTransition={spring}
                                            >
                                                <UssdItem item={item} />
                                            </motion.li>
                                        )
                                    })


                                    :
                                    <React.Fragment>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                        <li>
                                            <MyLoader />
                                        </li>
                                    </React.Fragment>
                            }
                        </ul>
                        : null}

                </div>
                <Footer />
                <Dialog
                    open={openNotification}
                    keepMounted
                    className="add-item"
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">مایل به دریافت اعلانات خانه نقره هستید؟ </DialogTitle>

                    <DialogActions>
                        <Button onClick={this.handleClose} className="cancel-btn" color="primary" style={{ marginLeft: 15 }}>
                            خیر
                    </Button>
                        <Button onClick={this.handleEnableNotifications} className="save-btn" color="primary" style={{ marginLeft: 15 }}>
                            بله
                    </Button>

                    </DialogActions>
                </Dialog>
            </div>


        );
    }
}
const mapStateToProps = state => {
    return {
        selectedTab: state.tabMode,
        socket: state.setSocket,
        app_name: state.nameMode
    }
}
export default connect(mapStateToProps)(Home);

